import config from "../../config"
import RequestService from "../RequestService"

const fetchOrganization = (id, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/organizations/${id}`, successCallback, failureCallback)
}

export default fetchOrganization;